'use strict';

{
  {
    /*====================================================
    ACCORDION
    ====================================================*/
    // アコーディオンを全て取得
    const accordions = document.querySelectorAll('.qa_list__item');
    // 取得したアコーディオンをArrayに変換(IE対策)
    const accordionsArr = Array.prototype.slice.call(accordions);

    accordionsArr.forEach(accordion => {
      // Triggerを全て取得
      const accordionTriggers = accordion.querySelectorAll('.qa_list__item_title');

      accordionTriggers.forEach(trigger => {
        // Triggerにクリックイベントを付与
        trigger.addEventListener('click', () => {
          // '.is-active'クラスを付与or削除
          trigger.classList.toggle('is-active');
          // 開閉させる要素を取得
          const content = accordion.querySelector('.qa_list__a');
          // 要素を展開or閉じる
          slideToggle(content);
        });
      });
    });
  }

  {
    /*====================================================
    SMOOTH SCROLL スピード・動きまで指定できるバージョン（.shopify-sectionの高さ考慮）
    ====================================================*/
    document.addEventListener('DOMContentLoaded', function () {
      function smoothScroll(target, duration) {
        const gnaviHeight = document.querySelector('.shopify-section').offsetHeight;
        const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - gnaviHeight;
        const startPosition = window.pageYOffset;
        const distance = targetPosition - startPosition;
        let startTime = null;

        function animation(currentTime) {
          if (startTime === null) startTime = currentTime;
          const timeElapsed = currentTime - startTime;
          const run = ease(timeElapsed, startPosition, distance, duration);
          window.scrollTo(0, run);
          if (timeElapsed < duration) requestAnimationFrame(animation);
        }

        // イージング関数
        function ease(t, b, c, d) {
          t /= d / 2;
          if (t < 1) return (c / 2) * t * t + b;
          t--;
          return (-c / 2) * (t * (t - 2) - 1) + b;
        }

        requestAnimationFrame(animation);
      }

      document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
          e.preventDefault();
          const speed = 500; // ミリ秒単位でスクロール時間を指定
          const href = this.getAttribute('href');
          const target = document.querySelector(href === '#' || href === '' ? 'html' : href);
          if (target) {
            smoothScroll(target, speed);
          }
        });
      });
    });
  }
}
